var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formName.errors.has(_vm.propName)
    ? _c("span", {
        staticClass: "help has-error admin-form-error",
        attrs: { role: "alert", "aria-live": "polite" },
        domProps: {
          textContent: _vm._s(_vm.formName.errors.get(_vm.propName)),
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }